import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    Button,
    Card,
    CardContent,
    CardMedia,
    Grid,
    List,
    ListItem,
    ListItemText,
    makeStyles,
    Paper,
    TextField,
    ThemeProvider,
    Typography,
} from "@material-ui/core";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import sellProductStyle, { theme } from "./sellProductStyle";

import { Creators as HomeActions } from "../../store/ducks/home";

import { MESSAGE_TYPES as msg } from "../../utils/js/constants";
import { notifySuccess, notifyError, notifyWarning } from "../../utils/js/helpers";
import Loader from "../Loader/Loader";
import InputSearch from "../InputSearch/InputSearch";
import NotFoundImg from "../../assets/not-found.png";

const useStyles = makeStyles((theme) => sellProductStyle(theme));

const SellProduct = ({ getProduct, updateProduct, home }) => {
    const classes = useStyles();
    const [query, setQuery] = React.useState(undefined);
    const [product, setProducts] = useState({
        Id: "",
        codigo: "",
        codigo_fornecedor: "",
        compatibilidade: [],
        estoque_atual: "",
        estoque_minimo: "",
        imagem: "",
        localizacao: "",
        nome: "",
        preco: "",
        segmento: [],
    });
    const [value, setValue] = React.useState(null);
    const { data, type, error, loading } = home;

    useEffect(() => {
        if (type === "home/SEARCH" && data?.Id) {
            setProducts(data);
        } else if (type === "home/SEARCH" && !data?.Id) {
            notifyError(msg.PRODUCT_NOT_FOUND);
        } else if (type === "home/UPDATE") {
            getProduct(query)
            notifySuccess(msg.PRODUCT_UPDATE);
        }
    }, [data, type, error, loading, product, value, query, getProduct]);

    React.useEffect(() => {
        if (typeof query !== "undefined") getProduct(query)
    }, [getProduct, query])

    const updateStock = () => {
        if (!product.Id) {
            return notifyError("Produto não encontrado");
        }
            
        if (!value) {
            return notifyWarning("Necessário selecionar uma quantidade");
        }

        const finalStock = product.estoque_atual - value;

        if (finalStock < 0) {
            notifyWarning("Quantidade maior que o estoque, por favor, diminua a quantidade");
        } else {
            updateProduct(finalStock, product);
        }
    };

    const handleImageError = (event) => {
        event.target.src = NotFoundImg;
    }
   
    const handleInput = (value) => {
        if (isNaN(parseInt(value)) || value < 1) {
            value = 1;
        }
        
        setValue(parseInt(value))
    }

    return loading ? (
        <Loader />
    ) : !product?.Id ? (
        <ThemeProvider theme={theme}>
            <Paper className={classes.containerSell}>
                <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                >
                    <Typography
                        component="h1"
                        variant="h5"
                        color="inherit"
                        noWrap
                        className={classes.title}
                    >
                        <LocalAtmIcon color="inherit" fontSize="inherit" />
                        Realizar Vendas
                    </Typography>
                </Grid>

                <InputSearch getProduct={setQuery} />

            </Paper>
        </ThemeProvider>
    ) : (
        <ThemeProvider theme={theme}>
            <Paper className={classes.containerSell}>
                <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                >
                    <Typography
                        component="h1"
                        variant="h5"
                        color="inherit"
                        noWrap
                        className={classes.title}
                    >
                        <LocalAtmIcon color="inherit" fontSize="inherit" />
                        Realizar Vendas
                    </Typography>
                </Grid>

                <InputSearch getProduct={setQuery} />

                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    className={classes.productDetails}
                >
                    <Card className={classes.card}>
                        <CardMedia
                            component="img"
                            onError={handleImageError}
                            className={classes.cover}
                            image={product.imagem}
                            title={product.nome}
                        />
                        <CardContent className={classes.content}>
                            <List
                                component="nav"
                                aria-label="main mailbox folders"
                                className={classes.productList}
                            >
                                <ListItem className={classes.listItem}>
                                    <ListItemText
                                        primary="Código:"
                                        secondary={product.codigo}
                                        className={classes.listItem}
                                    />
                                </ListItem>
                                <ListItem className={classes.listItem}>
                                    <ListItemText
                                        primary="Nome:"
                                        secondary={product.nome}
                                        className={classes.listItem}
                                    />
                                </ListItem>
                                <ListItem className={classes.listItem}>
                                    <ListItemText
                                        primary="Preço:"
                                        secondary={
                                            product.preco
                                                ? `R$${product.preco}`
                                                : ""
                                        }
                                        className={classes.listItem}
                                    />
                                </ListItem>
                                <ListItem className={classes.listItem}>
                                    <ListItemText
                                        primary="Código fornecedor:"
                                        secondary={product.codigo_fornecedor}
                                        className={classes.listItem}
                                    />
                                </ListItem>
                                <ListItem className={classes.listItem}>
                                    <ListItemText
                                        primary="Estoque mínimo:"
                                        secondary={product.estoque_minimo}
                                        className={classes.listItem}
                                    />
                                </ListItem>
                                <ListItem className={classes.listItem}>
                                    <ListItemText
                                        primary="Estoque atual:"
                                        secondary={product.estoque_atual}
                                        className={classes.listItem}
                                    />
                                </ListItem>
                                <ListItem className={classes.listItem}>
                                    <ListItemText
                                        primary="Localização:"
                                        secondary={product.localizacao}
                                        className={classes.listItem}
                                    />
                                </ListItem>
                            </List>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item direction="row" className={classes.containerButton}>
                    <Typography
                        component="p"
                        variant="p"
                        color="inherit"
                        noWrap
                        className={classes.titleChild}
                    >
                        Digite a quantidade de itens:
                    </Typography>

                    <TextField
                        id="productNumber"
                        type="number"
                        margin="none"
                        variant="outlined"
                        size="small"
                        className={classes.textSpace}
                        onChange={({target}) => handleInput(target.value)}
                        value={value}
                    />

                    <Button
                        variant="contained"
                        className={classes.sellButton}
                        onClick={() => updateStock()}
                    >
                        Efetuar venda
                    </Button>
                </Grid>
            </Paper>
        </ThemeProvider>
    );
};

const mapStateToProps = ({ home }) => ({ home });
const mapDispatchToProps = (dispatch) => {
    const { getProduct, updateProduct } = HomeActions;
    return bindActionCreators({ getProduct, updateProduct }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SellProduct);
